import React from 'react';
import { PricingData } from "components/pricing/calculator/Calculator_v2";

export function PricingDataMapper(res: any) {
    const pricing = new PricingData();
    const data = JSON.parse(res);

    pricing.plans = data.data;

    return pricing;
}
